import React from "react";
const icon = (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.25 4.875V13.5H4.875V4.875H19.25ZM4.875 2C4.1125 2 3.38124 2.3029 2.84207 2.84207C2.3029 3.38124 2 4.1125 2 4.875L2 13.5C2 14.2625 2.3029 14.9938 2.84207 15.5329C3.38124 16.0721 4.1125 16.375 4.875 16.375H19.25C20.0125 16.375 20.7438 16.0721 21.2829 15.5329C21.8221 14.9938 22.125 14.2625 22.125 13.5V4.875C22.125 4.1125 21.8221 3.38124 21.2829 2.84207C20.7438 2.3029 20.0125 2 19.25 2H4.875ZM45.125 36.5V45.125H30.75V36.5H45.125ZM30.75 33.625C29.9875 33.625 29.2562 33.9279 28.7171 34.4671C28.1779 35.0062 27.875 35.7375 27.875 36.5V45.125C27.875 45.8875 28.1779 46.6188 28.7171 47.1579C29.2562 47.6971 29.9875 48 30.75 48H45.125C45.8875 48 46.6188 47.6971 47.1579 47.1579C47.6971 46.6188 48 45.8875 48 45.125V36.5C48 35.7375 47.6971 35.0062 47.1579 34.4671C46.6188 33.9279 45.8875 33.625 45.125 33.625H30.75ZM19.25 25V45.125H4.875V25H19.25ZM4.875 22.125C4.1125 22.125 3.38124 22.4279 2.84207 22.9671C2.3029 23.5062 2 24.2375 2 25L2 45.125C2 45.8875 2.3029 46.6188 2.84207 47.1579C3.38124 47.6971 4.1125 48 4.875 48H19.25C20.0125 48 20.7438 47.6971 21.2829 47.1579C21.8221 46.6188 22.125 45.8875 22.125 45.125V25C22.125 24.2375 21.8221 23.5062 21.2829 22.9671C20.7438 22.4279 20.0125 22.125 19.25 22.125H4.875ZM45.125 4.875V25H30.75V4.875H45.125ZM30.75 2C29.9875 2 29.2562 2.3029 28.7171 2.84207C28.1779 3.38124 27.875 4.1125 27.875 4.875V25C27.875 25.7625 28.1779 26.4938 28.7171 27.0329C29.2562 27.5721 29.9875 27.875 30.75 27.875H45.125C45.8875 27.875 46.6188 27.5721 47.1579 27.0329C47.6971 26.4938 48 25.7625 48 25V4.875C48 4.1125 47.6971 3.38124 47.1579 2.84207C46.6188 2.3029 45.8875 2 45.125 2H30.75Z"
      fill="url(#paint0_linear_1471_3)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1471_3"
        x1="2"
        y1="25"
        x2="48"
        y2="25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A106E5" />
        <stop offset="1" stopColor="#8502E9" />
      </linearGradient>
    </defs>
  </svg>
);

export default icon;
